/**
 * ==== 职位管理 ====
 */

// 职位列表统计信息
export const LOAD_CATEGORY_START = "LOAD_CATEGORY_START";
export const LOAD_CATEGORY_DONE = "LOAD_CATEGORY_DONE";
export const JOB_CATEGORY = "JOB_CATEGORY";
// 职位列表
export const JOB_LIST = "JOB_LIST";
export const LOAD_LIST_START = "LOAD_LIST_START";
export const LOAD_LIST_DONE = "LOAD_LIST_DONE";
// 职位详细信息
export const JOB_INFO = "JOB_INFO";
export const LOAD_INFO_START = "LOAD_INFO_START";
export const LOAD_INFO_DONE = "LOAD_INFO_DONE";
// 提前终止职位信息
export const ABORT_JOB_START = "ABORT_JOB_START";
export const ABORT_JOB_DONE = "ABORT_JOB_DONE";
export const ABORT_JOB_INFO = "ABORT_JOB_INFO";
// 创建职位
export const CREATE_JOB_START = "CREATE_JOB_START";
export const CREATE_JOB_DONE = "CREATE_JOB_DONE";
// 职位信息MODAL
export const SHOW_JOB_MODAL = "SHOW_JOB_MODAL";
export const HIDE_JOB_MODAL = "HIDE_JOB_MODAL";
//职位发布成功MODAL
export const SHOW_SAVEJOB_MODAL = "SHOW_SAVEJOB_MODAL";
export const HIDE_SAVEJOB_MODAL = "HIDE_SAVEJOB_MODAL";
//清空职位信息数据
export const RESET_FORM = "RESET_FORM";
// 职位ID
export const RESUMEID = "RESUMEID";
// 清空职位ID
export const CANCELLRESUMEID = "CANCELLRESUMEID";
//薪资查询MODAL
export const SHOW_SALARY_MODAL = "SHOW_SALARY_MODAL";
export const HIDE_SALARY_MODAL = "HIDE_SALARY_MODAL";
//已查询到薪资数据
export const SALARYDATA = "SALARYDATA";
export const CANCELSALARY = "CANCELSALARY";
// 分配选择官的状态
export const ADD_TAGLIST = "ADD_TAGLIST";

// 选中表格的状态
export const CLEAR_CHOOSED_STATUS = "CLEAR_CHOOSED_STATUS";







// WEBPACK FOOTER //
// ./src/constants/job.js